import React from 'react';

function NotFound() {
  return (
    <div>
      <h1>Not Found!</h1>
      <p className="lead">This is not the page you're looking for!</p>
    </div>
  );
}

export default NotFound;
